// Path in repo: src/pages/organization-dashboard/components/analytics/EnrolledNow.jsx
//
// Shows learners currently active right now, broken down by program type.
// Pass `count` and `breakdown` (array of { label, share }) once wired to
// real enrollment/session data.

import React from "react"
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardAction } from "../../../../components/ui/card"
import { Delta, DeltaIcon, DeltaValue } from "../../../../components/delta"
import {
  ShareBarList, ShareBarListContent, ShareBarListFill,
  ShareBarListItem, ShareBarListLabel, ShareBarListValue,
} from "../../../../components/share-bar-list"

const FALLBACK_BREAKDOWN = [
  { label: "Self-paced courses", share: 58 },
  { label: "Cohort programs", share: 31 },
  { label: "Certifications", share: 11 },
]

const EnrolledNow = ({ count = 0, deltaPercent = null, breakdown }) => {
  const rows = breakdown?.length ? breakdown : FALLBACK_BREAKDOWN

  return (
    <Card className="gap-0 pb-0 md:col-span-2 lg:col-span-1 dark:bg-transparent">
      <CardHeader className="flex-row items-start justify-between gap-3">
        <div className="flex flex-col gap-0.5">
          <CardTitle className="font-mono text-2xl tabular-nums">{count}</CardTitle>
          <CardDescription className="flex items-center gap-1.5">
            <span className="relative flex size-1.5">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
              <span className="relative inline-flex size-1.5 rounded-full bg-emerald-500" />
            </span>
            learners active now
          </CardDescription>
        </div>
        {deltaPercent !== null && (
          <CardAction>
            <Delta value={deltaPercent} variant="badge">
              <DeltaIcon />
              <DeltaValue />
            </Delta>
          </CardAction>
        )}
      </CardHeader>
      <CardContent className="relative flex h-full items-center px-0 py-2">
        <ShareBarList>
          {rows?.map((row) => (
            <ShareBarListItem key={row?.label} value={row?.share}>
              <ShareBarListContent>
                <ShareBarListLabel>{row?.label}</ShareBarListLabel>
                <ShareBarListValue>{row?.share}%</ShareBarListValue>
              </ShareBarListContent>
              <ShareBarListFill />
            </ShareBarListItem>
          ))}
        </ShareBarList>
      </CardContent>
    </Card>
  )
}

export default EnrolledNow